export default "__VITE_ASSET__Cbstpka7__"